import React, { createContext, useEffect, useState } from "react";
import get from "lodash-es/get";
import { HtmlGameCallbacks, HtmlGameData } from "../types/game";
import { OnmoHtmlGame } from "../models/OnmoHtmlGame";

interface IHtmlGameContext {
  setGameData: (gameData?: HtmlGameData) => void;
  setCallbacks: (callbacks?: HtmlGameCallbacks) => void;
  setController: (controller?: OnmoHtmlGame) => void;
  controller?: OnmoHtmlGame;
  gameData?: HtmlGameData;
  callbacks?: HtmlGameCallbacks;
}

export const HtmlGameContext = createContext<IHtmlGameContext | null>(null);

interface HtmlGameProviderProps {
  children: React.ReactNode;
}

export const HtmlGameProvider: React.FC<HtmlGameProviderProps> = ({
  children,
}) => {
  const [gameData, setGameData] = useState<HtmlGameData>();
  const [callbacks, setCallbacks] = useState<HtmlGameCallbacks>();
  const [controller, setController] = useState<OnmoHtmlGame>();

  useEffect(() => {
    const observerCallback = () => {
      const gameCanvas =
        document.getElementById("gameCanvas") ||
        document.getElementById("UT_CANVAS") ||
        document.getElementById("game-phaser") ||
        document.getElementById("phaser-game");
      if (gameCanvas && (!gameData || !controller)) {
        gameCanvas.style.display = "none";
        document.body.style.setProperty("overflow", "scroll");
        gameCanvas?.parentNode?.removeChild(gameCanvas);
        // Fix issue can not replay unity game because canvasElement reference is not cleared
        const utCanvas = get(window, "ut._HTML");
        if (utCanvas) {
          utCanvas.canvasElement = undefined;
        }
      }
    };

    const observer = new MutationObserver(observerCallback);
    observer.observe(document.body, {
      childList: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [!!gameData, !!controller]);

  return (
    <HtmlGameContext.Provider
      value={{
        gameData,
        callbacks,
        controller,
        setController,
        setGameData,
        setCallbacks,
      }}
    >
      {children}
    </HtmlGameContext.Provider>
  );
};
